/* tslint:disable */
/* eslint-disable */
/**
 * Viewup Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface RegisterReqBodyDto
 */
export interface RegisterReqBodyDto {
    /**
     * 아이디
     * @type {string}
     * @memberof RegisterReqBodyDto
     */
    'id': string;
    /**
     * 비밀번호
     * @type {string}
     * @memberof RegisterReqBodyDto
     */
    'password': string;
    /**
     * 회원가입 경로
     * @type {string}
     * @memberof RegisterReqBodyDto
     */
    'registerPath': RegisterReqBodyDtoRegisterPathEnum;
    /**
     * 임시 유저 uuid
     * @type {string}
     * @memberof RegisterReqBodyDto
     */
    'tempUserUuid': string;
}

export const RegisterReqBodyDtoRegisterPathEnum = {
    FriendlyRecommend: 'friendlyRecommend',
    Search: 'search',
    Naver: 'naver',
    Youtube: 'youtube',
    Instagram: 'instagram',
    Facebook: 'facebook',
    Other: 'other'
} as const;

export type RegisterReqBodyDtoRegisterPathEnum = typeof RegisterReqBodyDtoRegisterPathEnum[keyof typeof RegisterReqBodyDtoRegisterPathEnum];


